import { LocalizedDateFromUtc, OptimusPlainLink, SpacedDash } from '@mews-commander/ui';

interface DatesRangeProps {
    startUtc: string;
    endUtc: string;
    onClick?: () => void;
}

export const DatesRange = ({ startUtc, endUtc, onClick }: DatesRangeProps) => {
    const datesRangeContent = (
        <>
            <LocalizedDateFromUtc utcString={startUtc} />
            {SpacedDash}
            <LocalizedDateFromUtc utcString={endUtc} />
        </>
    );

    return onClick ? (
        <OptimusPlainLink onClick={onClick} inherit>
            {datesRangeContent}
        </OptimusPlainLink>
    ) : (
        <span>{datesRangeContent}</span>
    );
};
